import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Container, Row, Col, Button, FloatingLabel, Form } from 'react-bootstrap';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTrash, faEdit } from "@fortawesome/free-solid-svg-icons";

import { accountService } from '../functions/registerApi';
import { shopService } from '../functions/shopApi';
import { authService } from '../functions/authenticate';
import { promoService } from '../functions/promoApi';

import "../scss/Cart.scss";


const Cart = ({ login, setLogin, userID, setUserID, setUserName, authToken, setAuthToken, itemList, setItemList, marathonLabel, marathonPrice, deliveryFee, testAddress, sst }) => {

    const navigate = useNavigate();
    const [subtotal, setSubtotal] = useState(0);
    const [taxableAmount, setTaxableAmount] = useState(0);
    const [tax, setTax] = useState(0);
    const [total, setTotal] = useState(0);
    const [tncCheck, setTncCheck] = useState(false);
    const [promo, setPromo] = useState('');
    const [runDiscountRate, setRunDiscountRate] = useState([]);
    const [discount, setDiscount] = useState(0);
    const [runnerList, setRunnerList] = useState([]);
    const [selectedList, setSelectedList] = useState([]);
    const [deliveryInfo, setDeliveryInfo] = useState({
        merchandiseCollection: 'Self-Collect',
        deliveryAddress: '',
        deliveryCity: '',
        deliveryPostcode: '',
        deliveryState: '',
        deliveryCountry: ''
    });
    const [merchandiseQty, setMerchandiseQty] = useState(0);

    useEffect(() => {

        let obj = {
            merchandiseCollection: 'Self-Collection',
            deliveryAddress: '',
            deliveryCity: '',
            deliveryPostcode: '',
            deliveryState: '',
            deliveryCountry: ''
        };


        if (itemList.length == 0) {
            shopService.getMerchandiseInfo()
                .then((response) => {

                    // console.log(response);

                    let merchandise = response.body.merchandise;
                    let newMerchandise = [];

                    merchandise.map((values, index) => {
                        let image = JSON.parse(values.imageURL);
                        let item = {
                            name: values.product_name,
                            image1: image[0],
                            price: parseFloat(values.price),
                            description: values.description
                        }
                        newMerchandise.push(item);
                    });

                    // console.log(newMerchandise);
                    setItemList(newMerchandise);

                })
                .catch((error) => {
                    console.log(error);
                });
        }


        let newRunnerList = localStorage.getItem('runnerList') === null ? [] : JSON.parse(localStorage.getItem('runnerList'));
        setRunnerList(newRunnerList);

        let newSelectedList = localStorage.getItem('selectedList') === null ? [] : JSON.parse(localStorage.getItem('selectedList'));
        setSelectedList(newSelectedList);
        // console.log(newSelectedList);

        let newDeliveryInfo = localStorage.getItem('deliveryInfo') === null ? obj : JSON.parse(localStorage.getItem('deliveryInfo'));
        setDeliveryInfo(newDeliveryInfo);

        let newPromo = localStorage.getItem('promoCode') === null ? '' : localStorage.getItem('promoCode');
        setPromo(newPromo);

        setRunDiscountRate({
            "42KM": 0,
            "21KM": 0,
            "10KM": 0,
            "5KM": 0
        });

        let paymentID = localStorage.getItem('paymentID') === null ? '' : localStorage.getItem('paymentID');
        // console.log(paymentID);

    }, []);

    useEffect(() => {
        const token = localStorage.getItem('authToken');
        if (token === '' || token === null) {
            navigate('/Login');
        }
        else {
            // console.log(token);
            authService.validateAuthToken(token)
                .then((response) => {
                    // console.log(response);
                    if (!response.status) {
                        navigate('/Login');
                    }
                    else if (!login) {
                        let data = response.body.user;
                        setUserID(data.individualID);
                        localStorage.setItem('userID', data.individualID);
                        // console.log(localStorage.getItem('userID'));
                        setLogin(true);

                        setUserName(data.firstname + ' ' + data.lastname);
                        localStorage.setItem('userName', data.firstname + ' ' + data.lastname);

                        setAuthToken(response.body.token);
                        localStorage.setItem('authToken', response.body.token);

                    }
                })
                .catch((error) => {
                    console.log(error);
                    navigate('/Login');
                })
        }

        let paymentID = localStorage.getItem('paymentID') === null ? '' : localStorage.getItem('paymentID');

    }, [authToken]);

    // Calculate total automatically when the lists changed
    useEffect(() => {

        // console.log(promo);
        if (promo !== "") {

            promoService.getPromoDetail(promo)
                .then((response) => {
                    // console.log(response);
                    if (response.status) {
                        setRunDiscountRate(response.body.promoRate);
                    }
                })
                .catch((err) => {
                    console.error(err.response);
                });

        } else {
            handlePrice();
        }

    }, [runnerList, selectedList, itemList, promo]);
    useEffect(() => {
        handlePrice();
    }, [runDiscountRate]);
    const handlePrice = () => {
        let newMerchandiseQty = 0;
        let newTax = 0;
        let newSubtotal = 0;
        let newRunSubTotal = 0;
        let newMerchandiseSubtotal = 0;
        let newDiscount = 0;
        let isTest = false;

        // add the price for marathon registration
        runnerList.map((runner, index) => {
            newRunSubTotal += marathonPrice[runner.category];
            newDiscount += marathonPrice[runner.category] * runDiscountRate[runner.category];
            if (runner.racePackCollection === "Delivery Service") {
                newRunSubTotal += deliveryFee;
            }

            if (testAddress.indexOf(runner.medicalAttention) !== -1) {
                isTest = true;
                localStorage.setItem("isFreeTest", "true");
            }
        });
        // add the price for merchandise
        if (itemList.length > 0) {
            selectedList.map((item, index) => {
                newMerchandiseQty += item.quantity;
                newMerchandiseSubtotal += itemList[item.item].price * item.quantity;
                if (deliveryInfo.merchandiseCollection === "Delivery Service") {
                    newMerchandiseSubtotal += (deliveryFee * item.quantity);
                }
            });
        }

        // Only run will apply tax
        newTax = newRunSubTotal * sst;

        newSubtotal = newRunSubTotal + newMerchandiseSubtotal;

        setMerchandiseQty(newMerchandiseQty);
        setSubtotal(newSubtotal);
        setTaxableAmount(newRunSubTotal);
        setTax(newTax);
        setDiscount(newDiscount);

        let newTotal = 0;
        newTotal = newSubtotal + newTax - newDiscount;

        if (promo === 'FORNEUTEST') {
            localStorage.setItem('promoCode', promo);
            setTotal(1);
        }
        else {
            setTotal(newTotal);
        }

    }

    // useEffect(() => {
    //     if(promo === 'FORNEUTEST')
    //     {
    //         setTotal(1);
    //     }
    //     localStorage.setItem('promoCode', promo);
    // }, [promo]);

    const handleRunRemove = (index) => {
        let arr = [...runnerList];
        if (index !== -1) {
            arr.splice(index, 1);
            arr.forEach((e, i) => e.index = i + 1)
            setRunnerList(arr);
            localStorage.setItem('runnerCount', arr.length);
            localStorage.setItem('runnerList', JSON.stringify(arr));
        }
    }
    const handleMerchandiseRemove = (index) => { // Remove item from cart
        let arr = [...selectedList];
        if (index !== -1) {
            arr.splice(index, 1);
            setSelectedList(arr);
            localStorage.setItem('selectedList', JSON.stringify(arr));
        }
    }
    const handleSubmit = () => {
        let userId = localStorage.getItem('userID');
        let paymentID = localStorage.getItem('paymentID') === null ? '' : localStorage.getItem('paymentID');

        // console.log(paymentID);
        // console.log(deliveryInfo);

        let platform = localStorage.getItem('device') === null ? '' : localStorage.getItem('device');

        if (runnerList.length > 0) {

            // console.log(runnerList);

            accountService.registerRunner(userId, runnerList, promo, paymentID, platform)
                .then((response) => {
                    // console.log(response);

                    if (response.body.pay_status) {

                        navigate('/PaymentDone/' + response.body.paymentID);

                    } else {

                        // update the promo code applied
                        localStorage.setItem('promoCode', promo);
                        // set the current paymentID
                        localStorage.setItem('paymentID', response.body.paymentID);

                        navigate('/Payment');

                    }

                })
                .catch(err => {
                    console.error(err.response);
                });

        } else {

            if (promo === 'FORNEUTEST' || promo === '' || promo === 'FORNEUTESTFREE') {
                shopService.addMerchandise(userId, selectedList, deliveryInfo, promo, paymentID, platform)
                    .then((response) => {

                        // console.log(response);

                        // update the promo code applied
                        localStorage.setItem('promoCode', promo);
                        // set the current paymentID
                        localStorage.setItem('paymentID', response.body.paymentID);

                        navigate('/Payment');

                    })
                    .catch(err => {
                        console.error(err.response);
                    });
            } else {
                alert('Please remove the merchandise(s) from your cart as the promo code or group code only can be applied on the marathon registration.');
            }

        }

    }

    return (
        <Container fluid="lg" className='wrapper'>

            <h1 className="title">My Cart</h1>

            <Row>
                <Col sm={12} md={8} lg={8} className="p-2">
                    <div className="Cart-box">
                        <ul className="Cart-list">
                            {runnerList.length > 0 && runnerList.map((values, index) => (
                                <li key={index}>
                                    {/* {console.log(values)} */}
                                    <Row className="cartItemList align-items-center">
                                        <Col sm={12} lg={12} className="itemDetail align-middle">
                                            <Row>
                                                <Col xs={{ order: 1, span: 12 }} sm={{ span: 12, order: 1 }} md={12} lg={12}>
                                                    <h4>{marathonLabel[values.category] + (values.category === '42KM' || values.category === '21KM' ? ' (' + values.category + ' ' + values.categoryType + ')' : '')}</h4>
                                                </Col>
                                                <Col xs={{ order: 3, span: 12 }} sm={{ span: 8, order: 2 }} md={8} lg={8} className="mt-1">
                                                    <span>{values.gender + ' | ' + (values.tshirt_type ?? "T-shirt") + ' : ' + values.tshirt_size + (values.finisher !== '' ? ' | Finisher size: ' + values.finisher : '')}</span>
                                                </Col>
                                                <Col xs={{ order: 4, span: 4 }} sm={{ span: 4, order: 3 }} md={4} lg={4} className="itemQty mt-1">
                                                    <span>x1</span>
                                                </Col>
                                                <Col xs={{ order: 2, span: 12 }} sm={{ span: 8, order: 4 }} md={8} lg={8} className="mt-1">
                                                    <h6>{values.firstname + ' ' + values.lastname}</h6>
                                                </Col>
                                                <Col xs={{ order: 5, span: 8 }} sm={{ span: 4, order: 5 }} md={4} lg={4} className="itemAmount mt-1">
                                                    RM <span>{marathonPrice[values.category].toFixed(2)}</span>
                                                </Col>
                                                {values.racePackCollection === "Delivery Service" && (
                                                    <>
                                                        <Col xs={{ order: 6, span: 6 }} sm={{ span: 8, order: 6 }} md={8} lg={8} className="mt-1">
                                                            <span>Delivery Service</span>
                                                        </Col>
                                                        <Col xs={{ order: 7, span: 6 }} sm={{ span: 4, order: 7 }} md={4} lg={4} className="itemAmount mt-1">
                                                            RM <span>20.00</span>
                                                        </Col>
                                                    </>
                                                )}
                                            </Row>
                                        </Col>
                                        <Col sm={12} md={12} lg={12} className="">
                                            <Button variant="outline-secondary float-end" size="sm" onClick={() => handleRunRemove(index)} ><FontAwesomeIcon icon={faTrash} /> Remove</Button>
                                            <Button variant="outline-secondary float-end" size="sm" onClick={() => { navigate('/Register/2') }} ><FontAwesomeIcon icon={faEdit} /> Edit</Button>
                                        </Col>
                                    </Row>
                                </li>
                            ))}
                            {itemList.length > 0 && selectedList.length > 0 && selectedList.map((values, index) => (
                                <li key={index}>
                                    <Row className="cartItemList align-items-center mt-3">
                                        <Col sm={12} lg={2} className="itemImage">
                                            <img src={`${process.env.PUBLIC_URL}/images/${itemList[values.item].image1}`} alt="Item image" />
                                        </Col>
                                        <Col sm={12} lg={10} className="itemDetail align-middle mt-2">
                                            <Row>
                                                <Col xs={{ order: 1 }} sm={{ span: 12, order: 1 }} md={12} lg={12}>
                                                    <h4>{itemList[values.item].name}</h4>
                                                </Col>
                                                {/* <Col sm={{span:8, order: }} md={8} lg={8} className="mt-1">
                                                    <span>{itemList[values.item].description}</span>
                                                </Col> */}
                                                <Col xs={{ order: 2 }} sm={{ span: 8, order: 2 }} md={8} lg={8} className="mt-1">
                                                    <span>Kuching Marathon 2026 Merchandise</span>
                                                </Col>
                                                <Col xs={{ order: 4, span: 4 }} sm={{ span: 4, order: 3 }} md={4} lg={4} className="itemQty mt-1">
                                                    <span>x{values.quantity}</span>
                                                </Col>
                                                <Col xs={{ order: 3 }} sm={{ span: 8, order: 4 }} md={8} lg={8} className="mt-1">
                                                    <h6>
                                                        {values.size === 'stock' ? (
                                                            <>

                                                            </>
                                                        ) : (
                                                            <>
                                                                <small style={{ color: "#777", fontWeight: "400" }}>Size:</small> {values.size}
                                                            </>
                                                        )}
                                                    </h6>
                                                </Col>
                                                <Col xs={{ order: 5, span: 8 }} sm={{ span: 4, order: 5 }} md={4} lg={4} className="itemAmount mt-1">
                                                    RM <span>{itemList[values.item].price.toFixed(2)}</span>
                                                </Col>
                                            </Row>
                                        </Col>
                                        <Col sm={12} md={12} lg={12} className="">
                                            <Button variant="outline-secondary float-end" size="sm" onClick={() => handleMerchandiseRemove(index)} ><FontAwesomeIcon icon={faTrash} /> Remove</Button>
                                            <Button variant="outline-secondary float-end" size="sm" onClick={() => { navigate('/Shop') }} ><FontAwesomeIcon icon={faEdit} /> Edit</Button>
                                        </Col>
                                    </Row>
                                </li>
                            ))}
                            {selectedList.length > 0 && deliveryInfo.merchandiseCollection === "Delivery Service" && (
                                <li>
                                    <Row className="cartItemList align-items-center mt-3">
                                        <Col sm={12} lg={12} className="itemDetail align-middle mt-2">
                                            <Row>
                                                <Col xs={{ order: 1 }} sm={{ span: 12, order: 1 }} md={12} lg={12}>
                                                    <h4>Merchandise Delivery Service</h4>
                                                </Col>
                                                <Col xs={{ order: 2 }} sm={{ span: 8, order: 2 }} md={8} lg={8} className="mt-1">
                                                    <span>{deliveryInfo.deliveryAddress}</span>
                                                </Col>
                                                <Col xs={{ order: 4, span: 4 }} sm={{ span: 4, order: 3 }} md={4} lg={4} className="itemQty mt-1">
                                                    <span>x{merchandiseQty}</span>
                                                </Col>
                                                <Col xs={{ order: 3 }} sm={{ span: 8, order: 4 }} md={8} lg={8} className="mt-1">
                                                    <span>{deliveryInfo.deliveryPostcode + " " + deliveryInfo.deliveryCity + ", " + deliveryInfo.deliveryState + ", " + deliveryInfo.deliveryCountry}</span>
                                                </Col>
                                                <Col xs={{ order: 5, span: 8 }} sm={{ span: 4, order: 5 }} md={4} lg={4} className="itemAmount mt-1">
                                                    RM <span>{(Math.round(deliveryFee * 100) / 100).toFixed(2)}</span>
                                                </Col>
                                                <Col xs={{ order: 6 }} sm={{ span: 12, order: 6 }} md={12} lg={12} className="">
                                                    <Button variant="outline-secondary float-end" size="sm" onClick={() => { navigate('/Shop') }} ><FontAwesomeIcon icon={faEdit} /> Edit</Button>
                                                </Col>
                                            </Row>
                                        </Col>
                                    </Row>
                                </li>
                            )}

                            {(runnerList.length > 0 || selectedList.length > 0) && (
                                <li>
                                    <Row className="align-items-center mt-3 text-end">
                                        <Col sm={6} md={8} lg={9} className="totalLabel">Item Total</Col>
                                        <Col sm={6} md={4} lg={3} className="totalAmount">RM <span>{subtotal.toFixed(2)}</span></Col>
                                    </Row>
                                </li>
                            )}
                            {(runnerList.length === 0 && selectedList.length === 0) && (
                                <li>
                                    No item added to cart yet.
                                </li>
                            )}

                        </ul>
                    </div>
                </Col>
                <Col sm={12} md={4} lg={4} className="p-2">
                    <div className="Cart-box">
                        <Row className="box-item top">
                            <div className="subtotalLabel">
                                Subtotal:
                            </div>
                            <div className="subtotalVal">
                                RM <span>{subtotal.toFixed(2)}</span>
                            </div>
                            <br /><br />
                            <div className="label">
                                Taxable Amount:
                            </div>
                            <div className="value">
                                RM <span>{taxableAmount.toFixed(2)}</span>
                            </div>
                            <br /><br />
                            <div className="label">
                                Tax ({sst * 100}%):
                            </div>
                            <div className="value">
                                RM <span>{tax.toFixed(2)}</span>
                            </div>
                            <br /><br />
                            <div className="label">
                                Discount:
                            </div>
                            <div className="value">
                                RM <span>{discount.toFixed(2)}</span>
                            </div>
                        </Row>

                        <hr />

                        <Row className="promo box-item">
                            <FloatingLabel controlId="floatingPromo" label="Promo Code">
                                <Form.Control type="text" placeholder="Promo Code" onChange={(e) => { setPromo(e.target.value); localStorage.setItem('promoCode', e.target.value) }} value={promo} disabled />
                            </FloatingLabel>

                            <div className="mt-2" id="tnc">
                                <input type="checkbox" value={tncCheck} onChange={(e) => { setTncCheck(!tncCheck) }} />
                                &nbsp;
                                I have read and agree to the <strong><a href="https://www.marathonkuching.com/register/images/Payment T&C.pdf" target="_blank">Online Registration and Payment Terms & Conditions</a></strong>
                            </div>


                        </Row>

                        <hr />

                        <Row className="box-item bottom">
                            <div className="subtotalLabel">
                                Total:
                            </div>
                            <div className="subtotalVal">
                                RM <span>{total.toFixed(2)}</span>
                            </div>
                            <Col className='mt-3'>
                                <Button type="submit" className="btn red-button form-control" disabled={!tncCheck} onClick={handleSubmit}>
                                    Checkout
                                </Button>
                            </Col>
                        </Row>
                    </div>
                </Col>
            </Row>

        </Container>
    );
}

export default Cart;